import React from 'react';
import styled from 'styled-components';

import VideoButton from './images/VideoButton';
import device from '../utils/device';
import { formatDate } from '../utils/format';

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  color: ${({ theme }) => theme.colors.textLight};

  padding: 5.5% 2rem 0 1.4rem;

  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${device.desktop} {
    padding: 12.5% 6.8rem 0 6rem;
  }
`;

const Title = styled.div`
  margin-top: 1.25rem;
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;

  @media ${device.desktop} {
    margin-top: 2.8rem;
    font-size: 1.65rem;
  }

  @media ${device.bigDesktop} {
    font-size: 3.35rem;
  }
`;

const SubTitle = styled.div`
  display: none;

  @media ${device.desktop} {
    display: block;
    margin-top: 0.5rem;
    font-size: 1.4rem;
  }

  @media ${device.bigDesktop} {
    font-size: 1.8rem;
  }
`;

const VideoOverlay = ({ video }) => {
  const isAvailable = new Date() > video.releaseDate;
  const overlayColor = isAvailable ? '#fff' : '#000';

  const overlayCopy = () => {
    if (!isAvailable) {
      return `Available ${formatDate(video.releaseDate)}`;
    }

    return `Play video ${video.id} now`;
  };

  return (
    <Container>
      <VideoButton color={overlayColor} text={`Video ${video.id}`} />
      <Title style={{ color: overlayColor }}>{video.title}</Title>
      <SubTitle style={{ color: overlayColor }}>{overlayCopy()}</SubTitle>
    </Container>
  );
};

export default VideoOverlay;
